var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"gst-venue-info mb-1"},[_vm._v(" "+_vm._s(_vm.venueName)+" "),_c('br'),_vm._v(" "+_vm._s(_vm._f("city")(_vm.venueCityLocation))+" "),_c('br')])}
var staticRenderFns = []

export { render, staticRenderFns }